import { render, staticRenderFns } from "./legal-confirm-distribution.vue?vue&type=template&id=1e52b926&scoped=true"
import script from "./legal-confirm-distribution.vue?vue&type=script&lang=ts"
export * from "./legal-confirm-distribution.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e52b926",
  null
  
)

export default component.exports